import styled from 'styled-components';

const EBarJobsResultDiv = styled.div`
  width: 100%;
`;

EBarJobsResultDiv.displayName = 'EBarJobsResultDiv';

export default EBarJobsResultDiv;
